import React from "react";
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
  render() {
    const searchData = this.props.searchData;
    const cashCustomerData = this.props.cashCustomerData;
    const TotalAmount = this.props.TotalAmount;

    const cellStyle = {
      border: '1px solid black',
      padding: '1px',
      fontSize: '0.9rem',
    };

    return (
      <div>
        <h2><center><u>Cash Customer Details Report</u></center></h2>
        <div>&nbsp;</div>
        <h2><center>{searchData.groupName} - {searchData.factoryName}</center></h2>
        <h3><center>{"Route:  " + (searchData.routeName || "All")}</center></h3>
        <h3><center> Bought Leaf Cash Payment for the Month of {searchData.applicableMonth} - {searchData.applicableYear}</center></h3>
        <div>&nbsp;</div>
        <div>
          <Box minWidth={1050} style={{paddingLeft:'10px', paddingRight:'10px'}}>
            <TableContainer>
              <Table aria-label="caption table">
                <TableHead>
                  <TableRow style={{ border: '1px solid black' }}>
                    <TableCell align="left" style={cellStyle}>Route Name</TableCell>
                    <TableCell align="left" style={cellStyle}>Registration Number</TableCell>
                    <TableCell align="left" style={cellStyle}>Customer Name</TableCell>
                    <TableCell align="right" style={cellStyle}>Amount(Rs)</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cashCustomerData.map((data, index) => (
                    <TableRow key={index} style={{ border: '1px solid black' }}>
                      <TableCell align="left" style={cellStyle}>
                        {data.routeName}
                      </TableCell>
                      <TableCell align="left" style={cellStyle}>
                        {data.registrationNumber}
                      </TableCell>
                      <TableCell align="left" style={cellStyle}>
                        {data.name}
                      </TableCell>
                      <TableCell align="right" style={cellStyle}>
                        {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableRow>
                  <TableCell align="left" style={cellStyle}>
                    <b>Total</b>
                  </TableCell>
                  <TableCell align="center" style={cellStyle}></TableCell>
                  <TableCell align="center" style={cellStyle}></TableCell>
                  <TableCell align="right" style={cellStyle}>
                    <b>
                      {new Intl.NumberFormat('en-US', {
                        style: 'decimal',
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }).format(TotalAmount)}
                    </b>
                  </TableCell>
                </TableRow>
              </Table>
            </TableContainer>
          </Box>
        </div>
        <div>&nbsp;</div>
        <h4><center>*******End of List*******</center></h4>
      </div>
    );
  }
}
